import { Component, computed, inject, ChangeDetectionStrategy } from '@angular/core';
import { LoadingWidgetDataService } from './loading-widget-data.service';

@Component({
    selector: 'adminui-loading-widget',
    imports: [],
    changeDetection: ChangeDetectionStrategy.OnPush,
    templateUrl: './loading-widget.component.html'
})
export class LoadingWidgetComponent {

  private readonly loadingWidgetDataService = inject(LoadingWidgetDataService);

  counter = this.loadingWidgetDataService.counter;
  show = computed(() => this.counter() > 0);
}
